import { connect } from 'react-redux';
import { showErrorFlag, showSuccessFlag } from '@helpcenter/flags';
import ProjectsList from './projects-list';

export default connect(null, {
	showErrorFlag,
	showSuccessFlag,
})(ProjectsList);
